import styled from "@emotion/styled";

export const FormSection = styled.div`
  flex: 2;
  width: 100%;
`;

export const UploadSection = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #fafafa;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  height: fit-content;
`;

export const ImageUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  label {
    font-size: 14px;
    font-weight: 600;
    color: #444;
    margin-bottom: 4px;
  }
`;
